import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeProvider } from 'styled-components';
import { loadMe, selectMe } from '../shared/store/me';
import ScrollToTop from '../shared/components/ScrollToTop';
import PageHead from '../shared/components/PageHead';
import { NavBar, USE_FRODOR_FOOTER } from '../../features/Layout/Nav';
import { Footer as FrodorFooter } from '../../features/Layout/Footer';
import { LayoutState } from '../../features/Layout';
import { darkTheme } from '../../features/Theme';
import { Track } from '../../features/Tracking';
import Layout from './Layout';
import Footer from './Footer';

class Root extends Component {
  static propTypes = {
    loadMe: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
    me: PropTypes.shape({
      isEmployee: PropTypes.bool,
      hasAccess: PropTypes.bool,
      username: PropTypes.string,
      features: PropTypes.objectOf(PropTypes.string),
      partnerIds: PropTypes.shape({
        google: PropTypes.string,
      }),
    }),
    children: PropTypes.node,
    forceState: PropTypes.string,
    defaultMenuState: PropTypes.shape({
      help: PropTypes.bool,
      resources: PropTypes.bool,
      side: PropTypes.bool,
    }),
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  componentDidMount() {
    this.props.loadMe();
  }

  render() {
    const isPlain = /\.plain$/.test(this.props.location.pathname);

    const NavComponent = () => {
      return (
        <LayoutState>
          <ThemeProvider theme={darkTheme}>
            <NavBar
              forceState={this.props.forceState}
              defaultMenuState={this.props.defaultMenuState}
            />
          </ThemeProvider>
        </LayoutState>
      );
      // legacy nav: <Navigation me={this.props.me} />
    };

    const FooterComponent = () => {
      return USE_FRODOR_FOOTER ? (
        <ThemeProvider theme={darkTheme}>
          <FrodorFooter />
        </ThemeProvider>
      ) : (
        <Footer />
      );
    };

    return (
      <>
        <PageHead />
        <ScrollToTop>
          <Track>
            <Layout
              navigation={!isPlain && <NavComponent />}
              content={this.props.children}
              footer={!isPlain && <FooterComponent />}
            />
          </Track>
        </ScrollToTop>
      </>
    );
  }
}

const selector = createStructuredSelector({
  me: selectMe,
});

const actions = { loadMe };

export default connect(selector, actions)(Root);
